import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field', 'form']
  static values = {
    message: String
  }

  connect() {
    this.message = ''
    this.beforeUnloadHandlerRef = this.beforeUnloadHandler.bind(this)
    this.turboBeforeVisitHandler = this.handleTurboBeforeVisit.bind(this)
    this.changeHandler = this.onChange.bind(this)
    this.submitHandler = this.onSubmit.bind(this)
    this.bindEvents()
    this.reset()
    this.element.dataset.tracker = this
    document.addEventListener("turbo:before-visit", this.turboBeforeVisitHandler)
  }

  disconnect() {
    this.unbindEvents()
    document.removeEventListener("turbo:before-visit", this.turboBeforeVisitHandler)
    this.reset()
  }

  bindEvents() {
    this.fields = Array.from(this.element.querySelectorAll('input, select, textarea'))
    this.fields.forEach((field) => {
      field.addEventListener('change', this.changeHandler)
    })
    this.element.addEventListener('submit', this.submitHandler)
  }

  unbindEvents() {
    this.fields?.forEach((field) => {
      field.removeEventListener('change', this.changeHandler)
    })
    this.element.removeEventListener('submit', this.submitHandler)
  }

  onChange(event) {
    if (!event.target.ignoreFormTracker) {
      this.markAsDirty()
    }
  }

  onSubmit() {
    this.reset()
  }

  handleTurboBeforeVisit(event) {
    if (!this.message) return

    const userConfirmed = confirm(this.messageValue)
    if (!userConfirmed) {
      event.preventDefault()
    } else {
      this.reset()
    }
  }

  markAsDirty(msg) {
    this.message = msg || this.messageValue
    window.addEventListener('beforeunload', this.beforeUnloadHandlerRef)
  }

  beforeUnloadHandler(event) {
    if (this.message) {
      event.preventDefault()
      event.returnValue = this.message  // Standard for beforeunload event
      return this.message
    }
  }

  reset() {
    this.message = ''
    window.removeEventListener('beforeunload', this.beforeUnloadHandlerRef)
  }

  confirmationMessage() {
    return this.message
  }
}
